// @ts-check
(function () {
  console.log('[IGT Options Summary] Script loaded - version with enhanced Bow Type/Manufacturer/Model detection - v2.2 (fixed input tracking)');
  
  // Immediate check and removal - run as soon as script loads
  function immediateGiftCardCheck() {
    // Check multiple indicators
    const pathname = window.location.pathname.toLowerCase();
    const hasGiftCardInUrl = pathname.includes('gift') || pathname.includes('igt');
    
    // Check for gift card form elements
    const hasDenominations = Array.from(document.querySelectorAll('label')).some(
      label => (label.textContent || '').toLowerCase().includes('denominations')
    );
    const hasSendTo = Array.from(document.querySelectorAll('label')).some(
      label => {
        const text = (label.textContent || '').toLowerCase();
        return text.includes('send to') && (text.includes('email') || text.includes('recipient'));
      }
    );
    
    // Check template
    const template = document.querySelector('main[data-template]')?.getAttribute('data-template') || '';
    const isGiftCardTemplate = template && (template.includes('gift') || template.includes('gift-card'));
    
    // If we detect gift card indicators, remove summary immediately
    if (hasDenominations && hasSendTo) {
      console.log('[IGT Options Summary] Gift card detected - removing Order Summary box immediately');
      const summary = document.querySelector('.igt-selection-summary');
      if (summary) {
        summary.remove();
        console.log('[IGT Options Summary] Order Summary box removed');
      }
      return true;
    }
    
    return false;
  }
  
  // Run immediate check
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', immediateGiftCardCheck);
  } else {
    immediateGiftCardCheck();
  }
  
  // Also run periodically to catch late-created boxes
  setInterval(() => {
    if (immediateGiftCardCheck()) {
      // Keep checking and removing
    }
  }, 500);
  
  /**
   * @param {string} sel
   * @param {Document|Element} [root=document]
   * @returns {Element[]}
   */
  function $all(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  /**
   * @param {string|null|undefined} raw
   * @returns {string}
   */
  function cleanLabel(raw) {
  if (!raw) return "";
  // Remove properties[...] wrapper
  raw = raw.replace(/^properties\[|\]$/g, "");
  // Remove any leftover prefixes
  raw = raw.replace(/^Option[:\s]*/i, "");
  // Remove info icon (ⓘ) and all text after it (tooltips, help text, etc.)
  raw = raw.replace(/ⓘ.*$/g, "");
  return raw.trim();
}

/**
 * @param {HTMLElement} el
 * @returns {string}
 */
function labelFor(el) {
  if (el.id) {
    const lbl = document.querySelector(`label[for="${CSS.escape(el.id)}"]`);
    if (lbl && lbl.textContent.trim()) return cleanLabel(lbl.textContent);
  }

  const inputEl = /** @type {HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement} */ (el);
  return cleanLabel(
    inputEl.name ||
    el.getAttribute("aria-label") ||
    "Option"
  );
}


  // Function to extract product title from the page
  function getProductTitle() {
    let fullTitle = '';
    
    // Try multiple methods to find the product title
    // Method 1: Look for h1 with product title
    const h1 = document.querySelector('h1');
    if (h1) {
      fullTitle = h1.textContent?.trim() || '';
    }
    
    // Method 2: Look for product title in product-details area
    if (!fullTitle) {
      const productTitleEl = document.querySelector('.product-details h1, .product-details [class*="product-title"], .product-details [class*="product_title"]');
      if (productTitleEl) {
        fullTitle = productTitleEl.textContent?.trim() || '';
      }
    }
    
    // Method 3: Look for meta tags
    if (!fullTitle) {
      const metaTitle = document.querySelector('meta[property="og:title"]');
      if (metaTitle) {
        fullTitle = metaTitle.getAttribute('content')?.trim() || '';
      }
    }
    
    // Method 4: Extract from page title
    if (!fullTitle) {
      fullTitle = document.title?.trim() || '';
    }
    
    if (!fullTitle || fullTitle.length === 0) {
      return '—';
    }
    
    // Try to extract just the material name (e.g., "452Xtra" from "Custom Compound Bow String – 452Xtra")
    // Look for patterns like "– 452Xtra", "| 452Xtra", or similar separators
    const separators = ['–', '-', '|', '•', '—'];
    for (const sep of separators) {
      if (fullTitle.includes(sep)) {
        const parts = fullTitle.split(sep);
        if (parts.length > 1) {
          // Take the last part and trim it (usually the material name)
          const materialName = parts[parts.length - 1]?.trim();
          if (materialName && materialName.length > 0) {
            return materialName;
          }
        }
      }
    }
    
    // If no separator found, try to extract common patterns
    // Look for alphanumeric patterns that might be material codes (e.g., "452Xtra", "X99", "B55")
    const materialPattern = /\b([A-Z]?\d+[A-Z]?\w*|[A-Z]+\d+[A-Z]?\w*|DynaFlight\s*\d+|B\d+|X\d+)\b/i;
    const match = fullTitle.match(materialPattern);
    if (match && match[1]) {
      return match[1].trim();
    }
    
    // If all else fails, return the full title
    return fullTitle;
  }

  /**
   * @typedef {Object} OptionItem
   * @property {string} label
   * @property {string} value
   * @property {boolean} [alwaysShow]
   * @property {boolean} [isProductTitle]
   * @property {string} [colorPreview]
   */
  
  /**
   * @param {Element|Document|HTMLElement|null|undefined} container
   * @returns {OptionItem[]}
   */
  function readOptions(container) {
    // Make sure we're using the Infinite Options container
    const infiniteOptionsContainer = document.getElementById('infiniteoptions-container');
    const searchContainer = infiniteOptionsContainer || container || document.body;
    
    const containerElForRead = /** @type {HTMLElement} */ (searchContainer instanceof Document ? document.body : searchContainer);
    console.log('[IGT Options Summary] readOptions called. Using container:', containerElForRead?.id || containerElForRead?.className || 'body/document');
    
    /** @type {OptionItem[]} */
    const out = [];
    const alwaysShowFields = ['bow type', 'bow manufacturer', 'bow model'];

    // Add String Material field first (always show with product title)
    const productTitle = getProductTitle();
    out.push({ 
      label: 'String Material', 
      value: productTitle, 
      alwaysShow: true,
      isProductTitle: true // Flag to identify this field
    });

    // Always include Bow Type, Manufacturer, and Model (even if empty)
    // Use robust detection similar to String Design detection
    console.log('[IGT Options Summary] 🔍 Starting alwaysShowFields detection (v2.1)...');
    const usedLabels = new Set(); // Track used labels to avoid reusing them
    const usedInputs = new Set(); // Track used input elements to avoid reusing them
    alwaysShowFields.forEach(fieldName => {
      console.log('[IGT Options Summary] Looking for field:', fieldName);
      const labels = searchContainer.querySelectorAll('label, .spb-productoptions-label, .igt-card-title, [class*="label"]');
      let found = false;
      
      for (let lbl of labels) {
        const labelText = (lbl.textContent || '').trim().toLowerCase();
        
        // Check if this label is for the field we're looking for
        // Be flexible - check for "bow type", "bow manufacturer", "bow model" variations
        // Strip info icons and normalize the text (remove ⓘ and everything after it)
        const normalizedLabel = labelText.replace(/ⓘ.*$/g, '').trim();
        
        // Make matching more specific to avoid cross-matching between fields
        let matchesField = false;
        if (fieldName === 'bow type') {
          matchesField = normalizedLabel.includes('bow type') || normalizedLabel === 'bow type' || normalizedLabel.startsWith('bow type');
        } else if (fieldName === 'bow manufacturer') {
          // Be specific - must include "manufacturer" and preferably "bow manufacturer"
          matchesField = normalizedLabel.includes('bow manufacturer') || 
                        (normalizedLabel.includes('manufacturer') && normalizedLabel.includes('bow') && !normalizedLabel.includes('model'));
        } else if (fieldName === 'bow model') {
          // Be specific - must include "model" and "bow", but NOT "manufacturer"
          matchesField = normalizedLabel.includes('bow model') || 
                        (normalizedLabel.includes('model') && normalizedLabel.includes('bow') && !normalizedLabel.includes('manufacturer'));
        }
        
        if (matchesField && !found) {
          // Skip if this label has already been used for another field
          if (usedLabels.has(lbl)) {
            console.log('[IGT Options Summary] ⚠️ Label already used, skipping:', labelText.substring(0, 80));
            continue;
          }
          
          console.log('[IGT Options Summary] ✅ Found matching label for', fieldName, '- Label text:', labelText.substring(0, 80), '- Normalized:', normalizedLabel);
          
          // Double-check: for bow model, ensure we're NOT matching bow manufacturer
          if (fieldName === 'bow model') {
            if (normalizedLabel.includes('manufacturer')) {
              console.log('[IGT Options Summary] ⚠️ Bow Model label includes "manufacturer" - rejecting match');
              continue;
            }
          }
          
          // Double-check: for bow manufacturer, ensure we're NOT matching bow model
          if (fieldName === 'bow manufacturer') {
            if (normalizedLabel.includes('model') && !normalizedLabel.includes('manufacturer')) {
              console.log('[IGT Options Summary] ⚠️ Bow Manufacturer label looks like Bow Model - rejecting match');
              continue;
            }
          }
          
          // Find the field container - try multiple methods (same as String Design detection)
          let field = lbl.closest('.spb-productoptions-field, .igt-field-card, fieldset, div[class*="field"], .igt-color-card');
          
          // If not found, walk up the DOM
          if (!field) {
            let current = lbl.parentElement;
            let depth = 0;
            while (current && depth < 15) {
              const className = (current.className || '').toString();
              const tagName = current.tagName || '';
              if (className.includes('field') || 
                  className.includes('spb-productoptions') || 
                  className.includes('igt') ||
                  tagName === 'FIELDSET' ||
                  (tagName === 'DIV' && (className.includes('card') || className.includes('option')))) {
                field = current;
                console.log('[IGT Options Summary] Found field container via DOM walk (depth:', depth, ') - Tag:', tagName, 'Classes:', className.substring(0, 80));
                break;
              }
              current = current.parentElement;
              depth++;
            }
          } else {
            console.log('[IGT Options Summary] Found field container via closest()');
          }
          
          if (field) {
            // For Bow Manufacturer and Bow Model, check text input first (they're text inputs)
            // For Bow Type, check select first (it's a dropdown)
            const isTextInputField = (fieldName === 'bow manufacturer' || fieldName === 'bow model');
            
            if (isTextInputField) {
              // Check for text input - verify it's associated with the correct label
              const labelForAttr = lbl.getAttribute('for');
              
              // First, try to find the input using the label's "for" attribute (most reliable)
              let input = null;
              if (labelForAttr) {
                input = document.getElementById(labelForAttr);
                if (input && (input.tagName !== 'INPUT' && input.tagName !== 'TEXTAREA')) {
                  input = null; // Not the right element type
                }
              }
              
              // If not found by "for" attribute, search within the field
              if (!input) {
                input = field.querySelector('input[type="text"], input[type="email"], textarea');
              }
              
              if (input) {
                // Skip if this input has already been used for another field
                if (usedInputs.has(input)) {
                  const inputEl = /** @type {HTMLInputElement|HTMLTextAreaElement} */ (input);
                  console.log('[IGT Options Summary] ⚠️ Input already used, skipping:', inputEl.id || inputEl.name || 'N/A');
                  continue; // Skip this label, try the next one
                }
                
                // Verify this input is actually associated with the label we found
                const inputEl = /** @type {HTMLInputElement|HTMLTextAreaElement} */ (input);
                const inputId = inputEl.id || '';
                const inputName = (inputEl.name || '').toLowerCase();
                const isAssociated = (inputId && labelForAttr && inputId === labelForAttr) || 
                                    (lbl.contains && lbl.contains(input)) ||
                                    (input.closest && input.closest('label') === lbl);
                
                // Also verify by checking input name/id matches the field we're looking for
                let matchesField = true;
                if (fieldName === 'bow manufacturer') {
                  // Input should contain "manufacturer" in name/id, NOT "model"
                  matchesField = (inputName.includes('manufacturer') || inputId.toLowerCase().includes('manufacturer')) &&
                                 !inputName.includes('model') && !inputId.toLowerCase().includes('model');
                } else if (fieldName === 'bow model') {
                  // Input should contain "model" in name/id, NOT "manufacturer"
                  matchesField = (inputName.includes('model') || inputId.toLowerCase().includes('model')) &&
                                 !inputName.includes('manufacturer') && !inputId.toLowerCase().includes('manufacturer');
                }
                
                if (!matchesField) {
                  console.log('[IGT Options Summary] ⚠️ Input name/id does not match field:', fieldName, '- Input ID:', inputId, 'Input name:', inputName);
                  continue; // Skip this input, try the next label
                }
                
                // Also verify the input is associated with this label
                if (!isAssociated && labelForAttr && inputId !== labelForAttr) {
                  console.log('[IGT Options Summary] ⚠️ Input not associated with label:', fieldName, '- Input ID:', inputId, 'Label for:', labelForAttr);
                  continue; // Skip this input, try the next label
                }
                
                const v = (inputEl.value || '').trim();
                
                // Show what user typed, only filter out obvious defaults
                let value = v || '—';
                if (v) {
                  const valueLower = v.toLowerCase();
                  // Only filter out bow type values that definitely shouldn't appear here
                  const bowTypeValues = ['compound bow', 'recurve bow', 'longbow', 'crossbow', 'traditional bow'];
                  const isBowTypeValue = bowTypeValues.some(dv => valueLower === dv);
                  if (isBowTypeValue) {
                    value = '—';
                    console.log('[IGT Options Summary] Filtered out bow type value in', fieldName);
                  } else {
                    // User typed something valid - show it
                    value = v;
                  }
                }
                
                const cleanLabelText = cleanLabel(lbl.textContent);
                out.push({ label: cleanLabelText, value: value, alwaysShow: true });
                usedLabels.add(lbl); // Mark this label as used
                usedInputs.add(input); // Mark this input as used
                console.log('[IGT Options Summary] ✅ Added', fieldName, '(text input) - Label:', cleanLabelText, 'Value:', value, 'Raw input value:', v, 'Input ID:', inputId, 'Input name:', inputName, 'Label for:', labelForAttr);
                found = true;
                break; // Stop looking once found
              }
            }
            
            // Check for select dropdown
            const select = field.querySelector('select');
            if (select) {
              // Skip if this select has already been used for another field
              if (usedInputs.has(select)) {
                console.log('[IGT Options Summary] ⚠️ Select already used, skipping:', select.id || select.name || 'N/A');
                continue; // Skip this label, try the next one
              }
              
              // Verify select is associated with this label
              const selectId = select.id || '';
              const selectName = (select.name || '').toLowerCase();
              const labelForAttr = lbl.getAttribute('for');
              const isAssociated = (selectId && labelForAttr && selectId === labelForAttr) || 
                                  (lbl.contains && lbl.contains(select));
              
              // Also verify by checking select name/id matches the field we're looking for
              let matchesField = true;
              if (fieldName === 'bow manufacturer') {
                matchesField = (selectName.includes('manufacturer') || selectId.toLowerCase().includes('manufacturer')) &&
                               !selectName.includes('model') && !selectId.toLowerCase().includes('model');
              } else if (fieldName === 'bow model') {
                matchesField = (selectName.includes('model') || selectId.toLowerCase().includes('model')) &&
                               !selectName.includes('manufacturer') && !selectId.toLowerCase().includes('manufacturer');
              }
              
              if (!matchesField || (!isAssociated && labelForAttr && selectId !== labelForAttr)) {
                console.log('[IGT Options Summary] ⚠️ Select not matching field or not associated - skipping:', fieldName);
                continue; // Skip this select, try the next label
              }
              
              const opt = select.options[select.selectedIndex];
              const v = (opt?.textContent || '').trim();
              let value = (!v || /select|choose/i.test(v)) ? '—' : v;
              
              // For Bow Manufacturer and Bow Model, check if value is a default that shouldn't be shown
              if ((fieldName === 'bow manufacturer' || fieldName === 'bow model') && value !== '—') {
                const valueLower = value.toLowerCase();
                const bowTypeValues = ['compound bow', 'recurve bow', 'longbow', 'crossbow', 'traditional bow'];
                const isBowTypeValue = bowTypeValues.some(dv => valueLower === dv);
                if (isBowTypeValue) {
                  value = '—';
                  console.log('[IGT Options Summary] Detected bow type value in', fieldName, '- showing "—" instead');
                }
              }
              
              const cleanLabelText = cleanLabel(lbl.textContent);
              out.push({ label: cleanLabelText, value: value, alwaysShow: true });
              usedLabels.add(lbl); // Mark this label as used
              usedInputs.add(select); // Mark this select as used
              console.log('[IGT Options Summary] ✅ Added', fieldName, '(select) - Label:', cleanLabelText, 'Value:', value, 'selectedIndex:', select.selectedIndex, 'Select ID:', selectId, 'Select name:', selectName);
              found = true;
              break; // Stop looking once found
            }
            
            // If text input field but no text input found yet, check for text input
            if (!isTextInputField) {
              const input = field.querySelector('input[type="text"], input[type="email"], textarea');
              if (input) {
                const inputEl = /** @type {HTMLInputElement|HTMLTextAreaElement} */ (input);
                const v = (inputEl.value || '').trim();
                const value = v || '—';
                const cleanLabelText = cleanLabel(lbl.textContent);
                out.push({ label: cleanLabelText, value: value, alwaysShow: true });
                console.log('[IGT Options Summary] ✅ Added', fieldName, '(text input fallback) - Label:', cleanLabelText, 'Value:', value);
                found = true;
                break;
              }
            }
            
            if (!found) {
              console.log('[IGT Options Summary] ⚠️ Found label and field container, but no select or text input found');
            }
          } else {
            console.log('[IGT Options Summary] ⚠️ Found matching label, but could not find field container');
          }
        }
      }
      
      // If still not found, try a fallback: search for input/select elements directly
      if (!found) {
        console.log('[IGT Options Summary] Trying fallback method for', fieldName, '- searching inputs/selects directly...');
        const allInputs = searchContainer.querySelectorAll('input[type="text"], input[type="email"], select, textarea');
        console.log('[IGT Options Summary] Found', allInputs.length, 'inputs/selects in container');
        
        for (let inputEl of allInputs) {
          // Get the label for this input
          const inputLabel = labelFor(/** @type {HTMLElement} */ (inputEl));
          const inputLabelLower = inputLabel.toLowerCase();
          
          // Normalize label (remove info icons - remove ⓘ and everything after it)
          const normalizedInputLabel = inputLabelLower.replace(/ⓘ.*$/g, '').trim();
          
          // Make matching more specific to avoid cross-matching between fields
          let matchesField = false;
          if (fieldName === 'bow type') {
            matchesField = normalizedInputLabel.includes('bow type') || normalizedInputLabel === 'bow type' || normalizedInputLabel.startsWith('bow type');
          } else if (fieldName === 'bow manufacturer') {
            // Be specific - must include "manufacturer" and preferably "bow manufacturer"
            matchesField = normalizedInputLabel.includes('bow manufacturer') || 
                          (normalizedInputLabel.includes('manufacturer') && normalizedInputLabel.includes('bow') && !normalizedInputLabel.includes('model'));
          } else if (fieldName === 'bow model') {
            // Be specific - must include "model" and "bow", but NOT "manufacturer"
            matchesField = normalizedInputLabel.includes('bow model') || 
                          (normalizedInputLabel.includes('model') && normalizedInputLabel.includes('bow') && !normalizedInputLabel.includes('manufacturer'));
          }
          
          if (matchesField && !found) {
            // Skip if this input has already been used for another field
            if (usedInputs.has(inputEl)) {
              const inputElTyped = /** @type {HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement} */ (inputEl);
              console.log('[IGT Options Summary] ⚠️ Input already used in fallback, skipping:', inputElTyped.id || inputElTyped.name || 'N/A');
              continue;
            }
            
            // Get the label for this input to check if it's already been used
            let inputLabelEl = null;
            if (inputEl.id) {
              inputLabelEl = document.querySelector(`label[for="${CSS.escape(inputEl.id)}"]`);
            }
            if (inputLabelEl && usedLabels.has(inputLabelEl)) {
              console.log('[IGT Options Summary] ⚠️ Input label already used in fallback, skipping');
              continue;
            }
            
            // Verify input name/id matches the field we're looking for
            const inputElTyped = /** @type {HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement} */ (inputEl);
            const inputId = inputElTyped.id || '';
            const inputName = (inputElTyped.name || '').toLowerCase();
            let inputMatchesField = true;
            if (fieldName === 'bow manufacturer') {
              // Input should contain "manufacturer" in name/id, NOT "model"
              inputMatchesField = (inputName.includes('manufacturer') || inputId.toLowerCase().includes('manufacturer')) &&
                                   !inputName.includes('model') && !inputId.toLowerCase().includes('model');
            } else if (fieldName === 'bow model') {
              // Input should contain "model" in name/id, NOT "manufacturer"
              inputMatchesField = (inputName.includes('model') || inputId.toLowerCase().includes('model')) &&
                                   !inputName.includes('manufacturer') && !inputId.toLowerCase().includes('manufacturer');
            }
            
            if (!inputMatchesField) {
              console.log('[IGT Options Summary] ⚠️ Input name/id does not match field in fallback:', fieldName, '- Input ID:', inputId, 'Input name:', inputName);
              continue; // Skip this input, try the next one
            }
            
            let value = '—';
            if (inputElTyped.tagName === 'SELECT') {
              const selectEl = /** @type {HTMLSelectElement} */ (inputElTyped);
              const opt = selectEl.options[selectEl.selectedIndex];
              const v = (opt?.textContent || '').trim();
              value = (!v || /select|choose/i.test(v)) ? '—' : v;
              
              // For Bow Manufacturer and Bow Model, check if value is a default that shouldn't be shown
              if ((fieldName === 'bow manufacturer' || fieldName === 'bow model') && value !== '—') {
                const valueLower = value.toLowerCase();
                // Check if value matches bow type values that shouldn't appear in Manufacturer/Model fields
                const bowTypeValues = ['compound bow', 'recurve bow', 'longbow', 'crossbow', 'traditional bow'];
                const isBowTypeValue = bowTypeValues.some(dv => valueLower === dv);
                if (isBowTypeValue) {
                  value = '—';
                  console.log('[IGT Options Summary] (fallback) Detected bow type value in', fieldName, '- showing "—" instead');
                }
              }
            } else {
              const inputOrTextarea = /** @type {HTMLInputElement|HTMLTextAreaElement} */ (inputElTyped);
              const v = (inputOrTextarea.value || '').trim();
              
              // For Bow Manufacturer and Bow Model, only filter out obvious default values
              // Don't filter based on placeholder - show what user actually typed
              value = v || '—';
              if (fieldName === 'bow manufacturer' || fieldName === 'bow model') {
                if (v) {
                  const valueLower = v.toLowerCase();
                  // Only filter out bow type values that definitely shouldn't appear here
                  const bowTypeValues = ['compound bow', 'recurve bow', 'longbow', 'crossbow', 'traditional bow'];
                  const isBowTypeValue = bowTypeValues.some(dv => valueLower === dv);
                  if (isBowTypeValue) {
                    value = '—';
                    console.log('[IGT Options Summary] (fallback) Filtered out bow type value in', fieldName);
                  } else {
                    // User typed something valid - show it
                    value = v;
                  }
                } else {
                  // Empty field - show "—"
                  value = '—';
                }
              }
            }
            const cleanLabelText = cleanLabel(inputLabel);
            out.push({ label: cleanLabelText, value: value, alwaysShow: true });
            // Mark the input and label as used
            usedInputs.add(inputEl);
            if (inputLabelEl) {
              usedLabels.add(inputLabelEl);
            }
            console.log('[IGT Options Summary] ✅ Added', fieldName, '(fallback method) - Label:', cleanLabelText, 'Value:', value, 'Input ID:', inputId, 'Input name:', inputName);
            found = true;
            break;
          }
        }
      }
      
      if (!found) {
        console.log('[IGT Options Summary] ❌ Could not find', fieldName, 'field after all attempts');
      }
    });

    // Regular fields (only show if they have values)
    $all("input[type='text'], textarea", searchContainer).forEach(el => {
      const inputEl = /** @type {HTMLInputElement|HTMLTextAreaElement} */ (el);
      const lbl = labelFor(/** @type {HTMLElement} */ (el));
      const normalizedLbl = cleanLabel(lbl).toLowerCase();
      // Skip if already included in alwaysShowFields (check if already in output array by label)
      const alreadyIncluded = out.some(item => {
        const itemLabel = cleanLabel(item.label).toLowerCase();
        return itemLabel === normalizedLbl || 
               (normalizedLbl.includes('bow type') && itemLabel.includes('bow type')) ||
               (normalizedLbl.includes('bow manufacturer') && itemLabel.includes('bow manufacturer')) ||
               (normalizedLbl.includes('bow model') && itemLabel.includes('bow model'));
      });
      if (alreadyIncluded) return;
      
      const v = (inputEl.value || "").trim();
      // For Bow Type, Manufacturer, Model - always include even if empty
      const isBowField = normalizedLbl.includes('bow type') || 
                         (normalizedLbl.includes('manufacturer') && normalizedLbl.includes('bow')) ||
                         (normalizedLbl.includes('bow model') || (normalizedLbl.includes('model') && normalizedLbl.includes('bow') && !normalizedLbl.includes('manufacturer')));
      
      if (isBowField) {
        // Always include bow fields, showing "—" if empty
        const value = v || '—';
        out.push({ label: lbl, value: value, alwaysShow: true });
        console.log('[IGT Options Summary] ✅ Added bow field via text input processing - Label:', cleanLabel(lbl), 'Value:', value);
      } else if (v) {
        out.push({ label: lbl, value: v });
      }
    });

    $all("select", searchContainer).forEach(el => {
      const selectEl = /** @type {HTMLSelectElement} */ (el);
      const lbl = labelFor(/** @type {HTMLElement} */ (el));
      const normalizedLbl = cleanLabel(lbl).toLowerCase();
      // Skip if already included in alwaysShowFields (check if already in output array by label)
      const alreadyIncluded = out.some(item => {
        const itemLabel = cleanLabel(item.label).toLowerCase();
        return itemLabel === normalizedLbl || 
               (normalizedLbl.includes('bow type') && itemLabel.includes('bow type')) ||
               (normalizedLbl.includes('bow manufacturer') && itemLabel.includes('bow manufacturer')) ||
               (normalizedLbl.includes('bow model') && itemLabel.includes('bow model'));
      });
      if (alreadyIncluded) return;
      
      const opt = selectEl.options[selectEl.selectedIndex];
      if (!opt) return;
      const v = (opt.textContent || "").trim();
      // For Bow Type, Manufacturer, Model - always include even if empty or default
      const isBowField = normalizedLbl.includes('bow type') || 
                         (normalizedLbl.includes('manufacturer') && normalizedLbl.includes('bow')) ||
                         (normalizedLbl.includes('bow model') || (normalizedLbl.includes('model') && normalizedLbl.includes('bow') && !normalizedLbl.includes('manufacturer')));
      
      if (isBowField) {
        // Always include bow fields, showing "—" if empty or default
        const value = (!v || /select|choose/i.test(v)) ? '—' : v;
        out.push({ label: lbl, value: value, alwaysShow: true });
        console.log('[IGT Options Summary] ✅ Added bow field via select processing - Label:', cleanLabel(lbl), 'Value:', value);
      } else if (v && !/select|choose/i.test(v)) {
        out.push({ label: lbl, value: v });
      }
    });

    // Check String Design selection to conditionally show/hide Second String Color
    let stringDesignValue = '';
    let isTwoColors = false;
    
    const containerElForString = searchContainer instanceof Document ? document.body : /** @type {HTMLElement} */ (searchContainer);
    console.log('[IGT Options Summary] Checking String Design. Container:', containerElForString?.id || containerElForString?.className || 'body/document');
    
    // Method 1: Look for String Design field by searching for labels first (most reliable)
    const allLabels = searchContainer.querySelectorAll('label, .spb-productoptions-label, .igt-card-title, [class*="label"]');
    console.log('[IGT Options Summary] Found', allLabels.length, 'labels in container');
    
    for (let lbl of allLabels) {
      const labelText = (lbl.textContent || '').trim().toLowerCase();
      console.log('[IGT Options Summary] Checking label:', labelText.substring(0, 50));
      
      // Check if this label is for String Design (but not Second String Color)
      if (labelText.includes('string design') && !labelText.includes('second')) {
        console.log('[IGT Options Summary] ✅ Found String Design label!');
        
        // Find the field container - try multiple methods
        let field = lbl.closest('.spb-productoptions-field, .igt-field-card, fieldset, div[class*="field"], .igt-color-card');
        
        // If not found, walk up the DOM
        if (!field) {
          let current = lbl.parentElement;
          let depth = 0;
          while (current && depth < 15) {
            const className = (current.className || '').toString();
            const tagName = current.tagName || '';
            if (className.includes('field') || 
                className.includes('spb-productoptions') || 
                className.includes('igt') ||
                tagName === 'FIELDSET' ||
                (tagName === 'DIV' && (className.includes('card') || className.includes('option')))) {
              field = current;
              break;
            }
            current = current.parentElement;
            depth++;
          }
        }
        
        if (field) {
          // Find the checked radio button in this field
          const checkedRadio = field.querySelector('input[type="radio"]:checked');
          if (checkedRadio) {
            console.log('[IGT Options Summary] Found checked radio in String Design field');
            
            // Get the value from multiple sources
            const radioEl = /** @type {HTMLInputElement} */ (checkedRadio);
            const dataValue = (radioEl.getAttribute("data-value") || '').toLowerCase();
            const radioValue = (radioEl.value || '').toLowerCase();
            const radioLabelEl = checkedRadio.closest('label');
            const radioLabelText = (radioLabelEl?.textContent || '').trim().toLowerCase();
            
            // Clean the label text to get just the option value
            let cleanLabelText = radioLabelText
              .replace(/string\s*design/gi, '')
              .replace(/^\s*[-–—|•]\s*/, '')
              .trim();
            
            // Try to extract the actual option value
            stringDesignValue = cleanLabelText || dataValue || radioValue || radioLabelText;
            
            console.log('[IGT Options Summary] String Design value detection:');
            console.log('  - dataValue:', dataValue);
            console.log('  - radioValue:', radioValue);
            console.log('  - radioLabelText:', radioLabelText);
            console.log('  - cleanLabelText:', cleanLabelText);
            console.log('  - final stringDesignValue:', stringDesignValue);
            
            // Check if it's "Two Colors" - be very permissive
            const twoColorsIndicators = [
              'two', '2', 'two color', 'two colors', '2 color', '2 colors',
              'dual', 'double', 'bi-color', 'bicolor'
            ];
            
            const valueToCheck = stringDesignValue + ' ' + dataValue + ' ' + radioValue + ' ' + cleanLabelText + ' ' + radioLabelText;
            const lowerValue = valueToCheck.toLowerCase();
            
            if (twoColorsIndicators.some(indicator => lowerValue.includes(indicator))) {
              isTwoColors = true;
              console.log('[IGT Options Summary] ✅ String Design is "Two Colors" - Second String Color will be shown');
              break; // Found it, no need to continue
            } else {
              console.log('[IGT Options Summary] ❌ String Design is NOT "Two Colors" (detected: "' + stringDesignValue + '")');
            }
          } else {
            console.log('[IGT Options Summary] No checked radio found in String Design field');
          }
        } else {
          console.log('[IGT Options Summary] Could not find field container for String Design label');
        }
      }
    }
    
    // Method 2: If still not found, check all checked radio buttons and their context
    if (!stringDesignValue || !isTwoColors) {
      console.log('[IGT Options Summary] Trying fallback method - checking all checked radios');
      const checkedRadios = $all("input[type='radio']:checked", searchContainer);
      
      checkedRadios.forEach((el, index) => {
        // Get all text around this radio button
        const radioLabelEl = el.closest('label');
        const radioLabelText = (radioLabelEl?.textContent || '').trim().toLowerCase();
        
        // Walk up to find parent field and check its label
        let current = el.parentElement;
        let foundStringDesign = false;
        
        for (let depth = 0; depth < 15 && current; depth++) {
          // Check if this element or its siblings contain "string design"
          const allText = (current.textContent || '').toLowerCase();
          if (allText.includes('string design') && !allText.includes('second string color')) {
            foundStringDesign = true;
            
            // Check if this radio is selected for "two colors"
            const radioEl = /** @type {HTMLInputElement} */ (el);
            const valueToCheck = (radioEl.getAttribute("data-value") || radioEl.value || radioLabelText).toLowerCase();
            if (valueToCheck.includes('two') || valueToCheck.includes('2')) {
              isTwoColors = true;
              stringDesignValue = valueToCheck;
              console.log('[IGT Options Summary] ✅ Found "Two Colors" via fallback method');
              return; // Break out of forEach
            }
            break;
          }
          current = current.parentElement;
        }
      });
    }

    // Check "Add Pinstripe?" selection to conditionally show/hide Pinstripe Color
    let isPinstripeEnabled = false;
    
    const containerElForPinstripe = searchContainer instanceof Document ? document.body : /** @type {HTMLElement} */ (searchContainer);
    console.log('[IGT Options Summary] Checking Add Pinstripe. Container:', containerElForPinstripe?.id || containerElForPinstripe?.className || 'body/document');
    
    // Look for "Add Pinstripe?" field by searching for labels
    for (let lbl of allLabels) {
      const labelText = (lbl.textContent || '').trim().toLowerCase();
      
      // Check if this label is for "Add Pinstripe?" (but not "Pinstripe Color")
      // Be more specific - must contain "add pinstripe" or "pinstripe?" but NOT "pinstripe color"
      const isAddPinstripeLabel = (labelText.includes('add pinstripe') || labelText.includes('pinstripe?')) && 
                                   !labelText.includes('pinstripe color') &&
                                   !labelText.includes('string design') &&
                                   !labelText.includes('string color');
      
      if (isAddPinstripeLabel) {
        console.log('[IGT Options Summary] ✅ Found Add Pinstripe label:', labelText.substring(0, 50));
        
        // Find the field container - be more specific to this label's field
        let field = lbl.closest('.spb-productoptions-field, .igt-field-card, fieldset, div[class*="field"], .igt-color-card');
        
        // Verify this field actually contains the "Add Pinstripe?" label and not other fields
        if (field) {
          const fieldText = (field.textContent || '').toLowerCase();
          // Make sure this field doesn't contain "String Design" or "String Color" (to avoid confusion)
          if (fieldText.includes('string design') || fieldText.includes('string color')) {
            console.log('[IGT Options Summary] Skipping field - contains String Design/Color, not Add Pinstripe');
            continue; // Skip this label and try the next one
          }
        }
        
        // If not found, walk up the DOM
        if (!field) {
          let current = lbl.parentElement;
          let depth = 0;
          while (current && depth < 15) {
            const className = (current.className || '').toString();
            const tagName = current.tagName || '';
            const currentText = (current.textContent || '').toLowerCase();
            
            // Make sure we're not picking up a field that contains "String Design" or "String Color"
            if (currentText.includes('string design') || currentText.includes('string color')) {
              break; // Stop here, don't use this field
            }
            
            if (className.includes('field') || 
                className.includes('spb-productoptions') || 
                className.includes('igt') ||
                tagName === 'FIELDSET' ||
                (tagName === 'DIV' && (className.includes('card') || className.includes('option')))) {
              field = current;
              break;
            }
            current = current.parentElement;
            depth++;
          }
        }
        
          if (field) {
          // Double-check: verify this field contains "Add Pinstripe?" and not "String Design"
          const fieldLabels = field.querySelectorAll('label, .spb-productoptions-label');
          let hasAddPinstripeLabel = false;
          let hasStringDesignLabel = false;
          
          fieldLabels.forEach(/** @param {HTMLElement} fl */ (fl) => {
            const flText = (fl.textContent || '').trim().toLowerCase();
            if ((flText.includes('add pinstripe') || flText.includes('pinstripe?')) && !flText.includes('pinstripe color')) {
              hasAddPinstripeLabel = true;
            }
            if (flText.includes('string design')) {
              hasStringDesignLabel = true;
            }
          });
          
          // Skip if this field contains "String Design" (wrong field)
          if (hasStringDesignLabel && !hasAddPinstripeLabel) {
            console.log('[IGT Options Summary] Skipping field - contains String Design, not Add Pinstripe');
            continue;
          }
          
          // Find the checked radio button, checkbox, or select dropdown in this field
            const checkedInput = field.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
            const selectInput = field.querySelector('select');
            
            let pinstripeValue = '';
            let dataValue = '';
            let inputValue = '';
            let inputLabelText = '';
            let cleanLabelText = '';
            
            if (selectInput) {
              // Handle select dropdown
              console.log('[IGT Options Summary] Found select dropdown in Add Pinstripe field');
              const selectedOption = selectInput.options[selectInput.selectedIndex];
              if (selectedOption) {
                inputValue = (selectedOption.value || '').toLowerCase();
                const optionText = (selectedOption.textContent || '').trim().toLowerCase();
                
                // Clean the option text to get just the value
                cleanLabelText = optionText
                  .replace(/add\s*pinstripe\??/gi, '')
                  .replace(/^\s*[-–—|•]\s*/, '')
                  .trim();
                
                pinstripeValue = cleanLabelText || inputValue || optionText;
                
                console.log('[IGT Options Summary] Add Pinstripe (select) value detection:');
                console.log('  - selectedOption.value:', selectedOption.value);
                console.log('  - optionText:', optionText);
                console.log('  - cleanLabelText:', cleanLabelText);
                console.log('  - final pinstripeValue:', pinstripeValue);
              }
            } else if (checkedInput) {
              // Handle radio button or checkbox
              console.log('[IGT Options Summary] Found checked input in Add Pinstripe field');
              
              // Verify this input is actually for "Add Pinstripe?" and not "String Design"
              const inputParent = checkedInput.closest('.spb-productoptions-field, fieldset, div[class*="field"]');
              const inputParentLabels = inputParent?.querySelectorAll('label, .spb-productoptions-label') || [];
              let isForAddPinstripe = false;
              
              inputParentLabels.forEach(/** @param {HTMLElement} pl */ (pl) => {
                const plText = (pl.textContent || '').trim().toLowerCase();
                if ((plText.includes('add pinstripe') || plText.includes('pinstripe?')) && !plText.includes('pinstripe color')) {
                  isForAddPinstripe = true;
                }
              });
              
              if (!isForAddPinstripe) {
                console.log('[IGT Options Summary] Skipping input - not for Add Pinstripe field');
                continue; // Skip this input, try next label
              }
              
              // Get the value from multiple sources
              const inputEl = /** @type {HTMLInputElement} */ (checkedInput);
              dataValue = (inputEl.getAttribute("data-value") || '').toLowerCase();
              inputValue = (inputEl.value || '').toLowerCase();
              const inputLabelEl = checkedInput.closest('label');
              inputLabelText = (inputLabelEl?.textContent || '').trim().toLowerCase();
              
              // Clean the label text to get just the option value
              cleanLabelText = inputLabelText
                .replace(/add\s*pinstripe\??/gi, '')
                .replace(/^\s*[-–—|•]\s*/, '')
                .trim();
              
              // Try to extract the actual option value
              pinstripeValue = cleanLabelText || dataValue || inputValue || inputLabelText;
              
              console.log('[IGT Options Summary] Add Pinstripe (radio/checkbox) value detection:');
              console.log('  - dataValue:', dataValue);
              console.log('  - inputValue:', inputValue);
              console.log('  - inputLabelText:', inputLabelText);
              console.log('  - cleanLabelText:', cleanLabelText);
              console.log('  - final pinstripeValue:', pinstripeValue);
            }
            
            if (pinstripeValue) {
              // Check if it's "Yes" - be very permissive
              const yesIndicators = [
                'yes', 'y', 'true', '1', 'on', 'enable', 'enabled', 'add'
              ];
              
              const valueToCheck = pinstripeValue + ' ' + dataValue + ' ' + inputValue + ' ' + cleanLabelText + ' ' + inputLabelText;
              const lowerValue = valueToCheck.toLowerCase();
              
              if (yesIndicators.some(indicator => lowerValue.includes(indicator))) {
                isPinstripeEnabled = true;
                console.log('[IGT Options Summary] ✅ Add Pinstripe is "Yes" - Pinstripe Color will be shown');
                break; // Found it, no need to continue
              } else {
                console.log('[IGT Options Summary] ❌ Add Pinstripe is NOT "Yes" (detected: "' + pinstripeValue + '") - Pinstripe Color will be hidden');
              }
            } else {
              console.log('[IGT Options Summary] No checked input or select found in Add Pinstripe field');
            }
        } else {
          console.log('[IGT Options Summary] Could not find field container for Add Pinstripe label');
        }
      }
    }
    
    // Fallback method: Check all checked radio buttons, checkboxes, and select dropdowns for "Add Pinstripe"
    if (!isPinstripeEnabled) {
      console.log('[IGT Options Summary] Trying fallback method for Add Pinstripe - checking all inputs and selects');
      
      // Check radio buttons and checkboxes
      const checkedInputs = $all("input[type='radio']:checked, input[type='checkbox']:checked", searchContainer);
      
      checkedInputs.forEach((el) => {
        // Get all text around this input
        const inputLabelEl = el.closest('label');
        const inputLabelText = (inputLabelEl?.textContent || '').trim().toLowerCase();
        
        // Walk up to find parent field and check its label
        let current = el.parentElement;
        
        for (let depth = 0; depth < 15 && current; depth++) {
          // Check if this element or its siblings contain "add pinstripe" (but not "pinstripe color")
          const allText = (current.textContent || '').toLowerCase();
          if ((allText.includes('add pinstripe') || allText.includes('pinstripe?')) && !allText.includes('pinstripe color')) {
            // Check if this input is selected for "yes"
            const inputEl = /** @type {HTMLInputElement} */ (el);
            const valueToCheck = (inputEl.getAttribute("data-value") || inputEl.value || inputLabelText).toLowerCase();
            if (valueToCheck.includes('yes') || valueToCheck.includes('y') || valueToCheck.includes('true') || valueToCheck.includes('1') || valueToCheck.includes('on')) {
              isPinstripeEnabled = true;
              console.log('[IGT Options Summary] ✅ Found "Yes" for Add Pinstripe via fallback method (radio/checkbox)');
              return; // Break out of forEach
            }
            break;
          }
          current = current.parentElement;
        }
      });
      
      // Check select dropdowns
      if (!isPinstripeEnabled) {
        const allSelects = $all("select", searchContainer);
        
        allSelects.forEach((select) => {
          // Walk up to find parent field and check its label
          let current = select.parentElement;
          
          for (let depth = 0; depth < 15 && current; depth++) {
            // Check if this element or its siblings contain "add pinstripe" (but not "pinstripe color")
            const allText = (current.textContent || '').toLowerCase();
            if ((allText.includes('add pinstripe') || allText.includes('pinstripe?')) && !allText.includes('pinstripe color')) {
              // Check if this select has "yes" selected
              const selectEl = /** @type {HTMLSelectElement} */ (select);
              const selectedOption = selectEl.options[selectEl.selectedIndex];
              if (selectedOption) {
                const optionValue = (selectedOption.value || '').toLowerCase();
                const optionText = (selectedOption.textContent || '').trim().toLowerCase();
                const valueToCheck = optionValue + ' ' + optionText;
                
                if (valueToCheck.includes('yes') || valueToCheck.includes('y') || valueToCheck.includes('true') || valueToCheck.includes('1') || valueToCheck.includes('on')) {
                  isPinstripeEnabled = true;
                  console.log('[IGT Options Summary] ✅ Found "Yes" for Add Pinstripe via fallback method (select)');
                  return; // Break out of forEach
                }
              }
              break;
            }
            current = current.parentElement;
          }
        });
      }
    }

    $all("input[type='radio']:checked", searchContainer).forEach(el => {
      const radioEl = /** @type {HTMLInputElement} */ (el);
      let label = labelFor(/** @type {HTMLElement} */ (el));
      let value = radioEl.getAttribute("data-value") || radioEl.value;
      
      // Check if this is Second String Color field - be more comprehensive
      const labelText = label.toLowerCase();
      const parentField = el.closest('.spb-productoptions-field, .igt-color-card, fieldset, div[class*="field"]');
      const parentLabel = parentField?.querySelector('label, .spb-productoptions-label');
      const parentLabelText = parentLabel?.textContent?.trim()?.toLowerCase() || '';
      
      // Also check parent's parent and siblings for the label
      const grandParent = parentField?.parentElement;
      const grandParentLabel = grandParent?.querySelector('label, .spb-productoptions-label');
      const grandParentLabelText = grandParentLabel?.textContent?.trim()?.toLowerCase() || '';
      
      const isSecondStringColor = labelText.includes('second string color') || 
                                  parentLabelText.includes('second string color') ||
                                  grandParentLabelText.includes('second string color');
      
      // Show/hide Second String Color based on String Design selection
      if (isSecondStringColor) {
        if (!isTwoColors) {
          console.log('[IGT Options Summary] Skipping Second String Color - String Design is not "Two Colors" (isTwoColors: ' + isTwoColors + ')');
          return; // Skip this field completely
        } else {
          console.log('[IGT Options Summary] Including Second String Color - String Design is "Two Colors"');
          
          // For Second String Color, use the parent field label as the label
          if (parentLabelText.includes('second string color') && parentLabel) {
            label = cleanLabel(parentLabel.textContent || '');
            console.log('[IGT Options Summary] Using parent label for Second String Color:', label);
          } else if (grandParentLabelText.includes('second string color') && grandParentLabel) {
            label = cleanLabel(grandParentLabel.textContent || '');
            console.log('[IGT Options Summary] Using grandparent label for Second String Color:', label);
          }
          
          // Extract the color name from the radio button - use same method as First String Color
          const radioLabelEl = el.closest('label');
          const radioLabelText = radioLabelEl?.textContent?.trim() || '';
          
          // Try to get color name from data-value first (most reliable)
          let extractedColorName = '';
          const dataValue = el.getAttribute('data-value');
          if (dataValue && dataValue !== 'on') {
            extractedColorName = dataValue;
          } else {
            const ariaLabel = el.getAttribute('aria-label');
            if (ariaLabel) {
              extractedColorName = ariaLabel;
            } else {
              const title = el.getAttribute('title');
              if (title) {
                extractedColorName = title;
              } else {
                // Clean the radio label text to get just the color name
                const cleanRadioLabel = radioLabelText
                  .replace(/string\s*color|second|first|pinstripe|end\s*serving|center\s*serving/gi, '')
                  .trim();
                if (cleanRadioLabel) {
                  extractedColorName = cleanRadioLabel;
                } else {
                  // Fallback to the raw value if nothing else works
                  extractedColorName = value;
                }
              }
            }
          }
          
          value = extractedColorName || '—'; // Ensure value is not empty
          
          console.log('[IGT Options Summary] Second String Color - Label:', label, 'Value:', value, 'radioLabelText:', radioLabelText.substring(0, 50), 'extractedColorName:', extractedColorName);
          // Continue to process this field and add it to the summary
        }
      }
      
      // Check if this is Pinstripe Color field - be more comprehensive
      const isPinstripeColor = labelText.includes('pinstripe color') || 
                               parentLabelText.includes('pinstripe color') ||
                               grandParentLabelText.includes('pinstripe color');
      
      // Show/hide Pinstripe Color based on Add Pinstripe selection
      if (isPinstripeColor) {
        if (!isPinstripeEnabled) {
          console.log('[IGT Options Summary] Skipping Pinstripe Color - Add Pinstripe is not "Yes" (isPinstripeEnabled: ' + isPinstripeEnabled + ')');
          return; // Skip this field completely
        } else {
          console.log('[IGT Options Summary] Including Pinstripe Color - Add Pinstripe is "Yes"');
          
          // For Pinstripe Color, use the parent field label as the label
          if (parentLabelText.includes('pinstripe color') && parentLabel) {
            label = cleanLabel(parentLabel.textContent || '');
            console.log('[IGT Options Summary] Using parent label for Pinstripe Color:', label);
          } else if (grandParentLabelText.includes('pinstripe color') && grandParentLabel) {
            label = cleanLabel(grandParentLabel.textContent || '');
            console.log('[IGT Options Summary] Using grandparent label for Pinstripe Color:', label);
          }
          
          // Extract the color name from the radio button - use same method as other color fields
          const radioLabelEl = el.closest('label');
          const radioLabelText = radioLabelEl?.textContent?.trim() || '';
          
          // Try to get color name from data-value first (most reliable)
          let extractedColorName = '';
          const dataValue = el.getAttribute('data-value');
          if (dataValue && dataValue !== 'on') {
            extractedColorName = dataValue;
          } else {
            const ariaLabel = el.getAttribute('aria-label');
            if (ariaLabel) {
              extractedColorName = ariaLabel;
            } else {
              const title = el.getAttribute('title');
              if (title) {
                extractedColorName = title;
              } else {
                // Clean the radio label text to get just the color name
                const cleanRadioLabel = radioLabelText
                  .replace(/pinstripe\s*color|pinstripe|string\s*color|second|first|end\s*serving|center\s*serving/gi, '')
                  .trim();
                if (cleanRadioLabel) {
                  extractedColorName = cleanRadioLabel;
                } else {
                  // Fallback to the raw value if nothing else works
                  extractedColorName = value;
                }
              }
            }
          }
          
          value = extractedColorName || '—'; // Ensure value is not empty
          
          console.log('[IGT Options Summary] Pinstripe Color - Label:', label, 'Value:', value, 'radioLabelText:', radioLabelText.substring(0, 50), 'extractedColorName:', extractedColorName);
          // Continue to process this field and add it to the summary
        }
      }
      
      // Check if this is a color swatch field - look for swatch in the label or nearby
      const labelEl = el.closest('label') || (el.id ? document.querySelector(`label[for="${CSS.escape(el.id)}"]`) : null);
      let swatchEl = null;
      let colorPreview = null;
      
      // Try multiple ways to find the swatch element
      if (labelEl) {
        swatchEl = labelEl.querySelector('.spb-productoptionswatch, .spb-productoptionswatchwrapper, [class*="swatch"]');
      }
      
      // If not found in label, check parent container
      if (!swatchEl) {
        const parent = el.closest('.spb-productoptions-field, .igt-color-card, [class*="field"]');
        if (parent) {
          const checkedLabel = parent.querySelector(`label:has(input[type="radio"]:checked)`);
          if (checkedLabel) {
            swatchEl = checkedLabel.querySelector('.spb-productoptionswatch, .spb-productoptionswatchwrapper, [class*="swatch"]');
          }
        }
      }
      
      if (swatchEl) {
        // First, try to get from the wrapper's style attribute (most reliable)
        const wrapper = swatchEl.closest('.spb-productoptionswatchwrapper, [class*="watchwrapper"]');
        if (wrapper) {
          const wrapperStyle = wrapper.getAttribute('style') || '';
          // Look for --swatch-background in style
          const swatchBgMatch = wrapperStyle.match(/--swatch-background:\s*([^;]+)/i);
          if (swatchBgMatch && swatchBgMatch[1]) {
            colorPreview = swatchBgMatch[1].trim();
          }
        }
        
        // Check swatch element's style attribute directly
        if (!colorPreview && swatchEl) {
          const swatchStyle = swatchEl.getAttribute('style') || '';
          const swatchBgMatch = swatchStyle.match(/--swatch-background:\s*([^;]+)/i);
          if (swatchBgMatch && swatchBgMatch[1]) {
            colorPreview = swatchBgMatch[1].trim();
          } else {
            // Try background in style
            const bgMatch = swatchStyle.match(/background[^:]*:\s*([^;]+)/i);
            if (bgMatch && bgMatch[1]) colorPreview = bgMatch[1].trim();
          }
        }
        
        // Try computed styles
        if (!colorPreview && swatchEl) {
          const computedStyle = window.getComputedStyle(swatchEl);
          
          // Check CSS custom property
          const swatchBg = computedStyle.getPropertyValue('--swatch-background')?.trim();
          if (swatchBg && swatchBg !== 'none') {
            colorPreview = swatchBg;
          }
          
          // Fallback to background-image
          if (!colorPreview) {
            const bgImage = computedStyle.backgroundImage;
            if (bgImage && bgImage !== 'none' && bgImage !== 'rgba(0, 0, 0, 0)') {
              colorPreview = bgImage;
            }
          }
          
          // Fallback to background-color
          if (!colorPreview) {
            const bgColor = computedStyle.backgroundColor;
            if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
              colorPreview = bgColor;
            }
          }
        }
        
        // Try parent element styles
        if (!colorPreview) {
          const parent = swatchEl.parentElement;
          if (parent) {
            const parentStyle = parent.getAttribute('style') || '';
            const swatchBgMatch = parentStyle.match(/--swatch-background:\s*([^;]+)/i);
            if (swatchBgMatch && swatchBgMatch[1]) {
              colorPreview = swatchBgMatch[1].trim();
            }
          }
        }
      }
      
      out.push({ 
        label: label, 
        value: value,
        colorPreview: colorPreview || undefined
      });
    });

    $all("input[type='checkbox']:checked", searchContainer).forEach(el => {
      const checkboxEl = /** @type {HTMLInputElement} */ (el);
      out.push({ label: labelFor(/** @type {HTMLElement} */ (el)), value: checkboxEl.getAttribute("data-value") || checkboxEl.value });
    });

    // Sort: String Material first, then alwaysShowFields, then others
    /** @type {OptionItem[]} */
    const sorted = [];
    
    // Add String Material first (if it exists)
    const stringMaterialItem = out.find(x => x.isProductTitle);
    if (stringMaterialItem && stringMaterialItem.value) {
      sorted.push(stringMaterialItem);
    }
    
    // Add alwaysShowFields (Bow Type, Manufacturer, Model)
    // First, try to find by alwaysShow flag
    const alwaysShowItems = out.filter(x => x.alwaysShow && !x.isProductTitle);
    alwaysShowItems.forEach(item => {
      if (!sorted.includes(item)) {
        sorted.push(item);
      }
    });
    
    // Also try by field name matching (fallback if alwaysShow flag missing)
    alwaysShowFields.forEach(fieldName => {
      const item = out.find(x => {
        const labelLower = x.label.toLowerCase();
        const matchesField = 
          (fieldName === 'bow type' && (labelLower.includes('bow type') || labelLower === 'bow type')) ||
          (fieldName === 'bow manufacturer' && (labelLower.includes('bow manufacturer') || (labelLower.includes('manufacturer') && labelLower.includes('bow')))) ||
          (fieldName === 'bow model' && (labelLower.includes('bow model') || (labelLower.includes('model') && labelLower.includes('bow') && !labelLower.includes('manufacturer'))));
        return matchesField && !x.isProductTitle && !sorted.includes(x);
      });
      if (item) {
        sorted.push(item);
      }
    });
    
    // Add remaining items (that aren't already in sorted)
    out.forEach(item => {
      if (!item.alwaysShow && !sorted.includes(item) && !item.isProductTitle) {
        sorted.push(item);
      }
    });
    
    console.log('[IGT Options Summary] Sorting complete. Total items:', sorted.length);
    console.log('[IGT Options Summary] alwaysShowItems found:', alwaysShowItems.length);
    if (alwaysShowItems.length > 0) {
      console.log('[IGT Options Summary] alwaysShowItems labels:', alwaysShowItems.map(x => x.label));
    }

    // de-dupe
    return sorted.filter((x, i, arr) => arr.findIndex(y => y.label === x.label && y.value === x.value) === i);
  }

  /**
   * @param {HTMLElement} summaryEl
   * @param {OptionItem[]} items
   */
  function render(summaryEl, items) {
    // Always show summary box, even if empty (for Bow Type, Manufacturer, Model)
    summaryEl.innerHTML = `
      <h3 class="igt-summary-title">Order Summary</h3>
      <dl class="igt-selection-list">${items.map(/** @param {OptionItem} i */ (i) => {
        let valueContent = i.value;
        
        // Add color preview if available
        if (i.colorPreview) {
          let style = '';
          // Handle different color preview formats
          const preview = i.colorPreview.trim();
          
          if (preview.includes('url(')) {
            // Background image
            style = `background-image: ${preview}; background-size: cover; background-position: center; background-repeat: no-repeat;`;
          } else if (preview.startsWith('rgb(') || preview.startsWith('rgba(') || preview.startsWith('#')) {
            // Solid color
            style = `background-color: ${preview};`;
          } else if (preview.startsWith('rgb')) {
            // RGB without parentheses
            style = `background-color: ${preview};`;
          } else {
            // Try as CSS variable or direct value
            style = `background: ${preview}; background-size: cover; background-position: center; background-repeat: no-repeat;`;
          }
          
          valueContent = `<span class="igt-color-preview" style="${style}"></span><span>${i.value}</span>`;
        }
        
        return `
        <div class="igt-selection-item">
          <dt class="igt-selection-label">${i.label}</dt>
          <dd class="igt-selection-value">${valueContent}</dd>
        </div>`;
      }).join("")}</dl>
    `;
  }

  function shouldSkipSummary() {
    // Check template name from main element
    const mainElement = document.querySelector('main[data-template]');
    const template = mainElement?.getAttribute('data-template') || '';
    
    console.log('[IGT Options Summary] Current template:', template, 'URL:', window.location.pathname);
    
    // Check for gift-card template (flexible check for various naming conventions)
    if (template && (template.includes('gift-card') || template.includes('gift_card') || template === 'product.gift-card')) {
      console.log('[IGT Options Summary] Skipping Order Summary box on gift-card template:', template);
      return true;
    }
    
    // Check URL path as fallback
    const pathname = window.location.pathname.toLowerCase();
    if (pathname && (pathname.includes('gift-card') || pathname.includes('gift_card') || pathname.includes('/products/gift'))) {
      console.log('[IGT Options Summary] Skipping Order Summary box - gift-card detected in URL');
      return true;
    }
    
    // Check product title for "gift card" (case insensitive)
    const productTitle = document.querySelector('h1, [class*="product-title"], [class*="product_title"]');
    if (productTitle) {
      const titleText = (productTitle.textContent || '').toLowerCase();
      if (titleText.includes('gift card') || titleText.includes('gift-card')) {
        console.log('[IGT Options Summary] Skipping Order Summary box - gift card detected in product title');
        return true;
      }
    }
    
    // Check if product is a gift card (look for gift card form elements)
    const giftCardForm = document.querySelector('form[action*="/cart/add"] [name*="properties[Recipient email]"], form[action*="/cart/add"] [name*="properties[Recipient\'s email]"], [id*="gift-card-delivery"]');
    if (giftCardForm) {
      console.log('[IGT Options Summary] Skipping Order Summary box - gift card form detected');
      return true;
    }
    
    // Check for "Send to" section which is common on gift cards
    // Look for labels or text containing "Send to"
    const allLabels = document.querySelectorAll('label');
    for (let label of allLabels) {
      const labelText = (label.textContent || '').toLowerCase();
      if (labelText.includes('send to') && (labelText.includes('email') || labelText.includes('recipient'))) {
        console.log('[IGT Options Summary] Skipping Order Summary box - "Send to" section detected (gift card indicator)');
        return true;
      }
    }
    
    // Check for "Denominations" which is specific to gift cards
    const denominationsLabel = Array.from(document.querySelectorAll('label')).find(
      label => (label.textContent || '').toLowerCase().includes('denominations')
    );
    if (denominationsLabel) {
      // Check if there's also a "Send to" field nearby (gift card indicator)
      const nearbyLabels = Array.from(document.querySelectorAll('label')).filter(
        label => {
          const text = (label.textContent || '').toLowerCase();
          return text.includes('send to') || text.includes('recipient');
        }
      );
      if (nearbyLabels.length > 0) {
        console.log('[IGT Options Summary] Skipping Order Summary box - Denominations + Send to detected (gift card)');
        return true;
      }
    }
    
    return false;
  }
  
  // Function to remove existing Order Summary box
  function removeSummaryBox() {
    const summaryBox = document.querySelector('.igt-selection-summary');
    if (summaryBox) {
      console.log('[IGT Options Summary] Removing existing Order Summary box');
      summaryBox.remove();
      return true;
          }
          return false;
  }

  // Remove any summary boxes in wrong locations (above product title or duplicates)
  function removeDuplicateSummaryBoxes() {
    const allSummaryBoxes = document.querySelectorAll('.igt-selection-summary');
    if (allSummaryBoxes.length <= 1) return; // Only one or none, we're good
    
    console.log(`[IGT Options Summary] Found ${allSummaryBoxes.length} summary boxes, checking for duplicates...`);
    
    // Find the product title
    const productTitle = document.querySelector('h1, [class*="product-title"], [class*="product_title"], .view-product-title');
    
    // Remove summary boxes that are above the product title - these are definitely wrong
    allSummaryBoxes.forEach((summary) => {
      if (productTitle && summary.compareDocumentPosition(productTitle) & Node.DOCUMENT_POSITION_PRECEDING) {
        // Summary is before the product title - this is wrong, remove it
        console.log('[IGT Options Summary] Removing summary box above product title');
        summary.remove();
      }
    });
    
    // Now check remaining boxes and keep only one in a good location
    const remainingBoxes = document.querySelectorAll('.igt-selection-summary');
    if (remainingBoxes.length > 1) {
      let keptOne = false;
      remainingBoxes.forEach((summary) => {
        const parent = summary.parentElement;
        const isInRightColumn = parent?.querySelector('.group-block--fill, [class*="right"]') || 
                                parent?.classList.contains('group-block--fill') ||
                                parent?.classList.toString().includes('right');
        const isInProductDetails = parent?.querySelector('.product-details') || 
                                   parent?.classList.toString().includes('product-details');
        
        if ((isInRightColumn || isInProductDetails) && !keptOne) {
          // This is in a good location and we haven't kept one yet - keep it
          keptOne = true;
        } else {
          // This is either in a bad location or we already kept one - remove it
          console.log('[IGT Options Summary] Removing duplicate summary box');
          summary.remove();
        }
      });
    }
  }

  function init() {
    console.log('[IGT Options Summary] Init function called');
    
    // Check if we should skip the Order Summary box
    if (shouldSkipSummary()) {
      console.log('[IGT Options Summary] Gift card detected - removing any existing summary and skipping initialization');
      removeSummaryBox();
      return; // Don't initialize Order Summary box
    }
    
    // First, clean up any existing duplicate summary boxes
    removeDuplicateSummaryBoxes();

    // Try multiple ways to find the right container
    function tryInit() {
      // Check if we already have a summary box in a good location
      const existingSummary = document.querySelector('.igt-selection-summary');
      if (existingSummary) {
        const parent = existingSummary.parentElement;
        const isInRightColumn = parent?.querySelector('.group-block--fill, [class*="right"]') || 
                                parent?.classList.contains('group-block--fill') ||
                                parent?.classList.toString().includes('right');
        const isInProductDetails = parent?.querySelector('.product-details') || 
                                   parent?.classList.toString().includes('product-details');
        
        if (isInRightColumn || isInProductDetails) {
          console.log('[IGT Options Summary] Summary box already exists in correct location, skipping initialization');
          // Still check for duplicates in case there are multiple
          removeDuplicateSummaryBoxes();
          return; // Already have a good summary box, don't create another
        }
      }
      
      // Method 1: Look for sticky layout wrapper (preferred method)
      const stickyWrapper = document.querySelector(".section-content-wrapper.igt-sticky-layout");
      if (stickyWrapper) {
        const left = stickyWrapper.firstElementChild;
        const right = stickyWrapper.lastElementChild;
        if (left && right) {
          setupSummary(left, right);
          console.log('[IGT Options Summary] Created summary box using sticky layout wrapper');
          removeDuplicateSummaryBoxes(); // Clean up any extras
          return; // Success, don't try other methods
        }
      }

      // Method 2: Look for product details area with right column
      const productDetails = document.querySelector('.product-details, [class*="product-details"], [class*="product-information"]');
      if (productDetails) {
        const container = document.querySelector("#infiniteoptions-container") || document.body;
        const parent = productDetails.closest('.section-content-wrapper, .layout-panel-flex, .group-block');
        if (parent) {
          const rightColumn = parent.querySelector('.group-block--fill, [class*="right"]');
          if (rightColumn) {
            setupSummary(container, rightColumn);
            console.log('[IGT Options Summary] Created summary box using product details with right column');
            removeDuplicateSummaryBoxes(); // Clean up any extras
            return; // Success
          }
        }
      }

      // Method 3: Look for Infinite Options container and find best parent
      const infiniteContainer = document.getElementById('infiniteoptions-container');
      if (infiniteContainer) {
        const parentSection = infiniteContainer.closest('section, .section-content-wrapper, [class*="section"]');
        if (parentSection) {
          const rightCol = parentSection.querySelector('.group-block--fill, [class*="right"]');
          if (rightCol) {
            setupSummary(infiniteContainer, rightCol);
            console.log('[IGT Options Summary] Created summary box using Infinite Options container with right column');
            removeDuplicateSummaryBoxes(); // Clean up any extras
            return; // Success
          }
        }
      }
      
      // Final cleanup of any duplicates
      removeDuplicateSummaryBoxes();
    }

    /**
     * @param {Element|null|undefined} optionsContainer
     * @param {Element|null|undefined} summaryParent
     */
    function setupSummary(optionsContainer, summaryParent) {
      if (!optionsContainer || !summaryParent) return;

      // Find or create summary element
      let summaryEl = summaryParent.querySelector(".igt-selection-summary");
      if (!summaryEl) {
        summaryEl = document.createElement("div");
        summaryEl.className = "igt-selection-summary";
        summaryEl.setAttribute("aria-live", "polite");
        
        // Try to prepend to right column, or append to parent
        if (summaryParent.querySelector('.group-block--fill, [class*="right"]')) {
          const rightCol = summaryParent.querySelector('.group-block--fill, [class*="right"]');
          rightCol?.prepend(summaryEl);
        } else {
          summaryParent.prepend(summaryEl);
        }
      }

      // Find the actual Infinite Options container
      const actualContainer = optionsContainer.querySelector && optionsContainer.querySelector("#infiniteoptions-container")
        ? optionsContainer
        : (typeof optionsContainer === 'string' 
            ? document.getElementById('infiniteoptions-container')
            : (optionsContainer.id === 'infiniteoptions-container' 
                ? optionsContainer 
                : document.getElementById('infiniteoptions-container') || optionsContainer));

      // Function to toggle Second String Color field visibility
      function toggleSecondStringColor() {
        const container = actualContainer || document.getElementById('infiniteoptions-container') || document.body;
        
        // Find String Design field - try multiple selectors
    let isTwoColors = false;
        
        // Try to find by label text
    const allLabels = container.querySelectorAll('label, .spb-productoptions-label');
    allLabels.forEach(/** @param {HTMLElement} label */ (label) => {
      const labelText = (label.textContent || '').trim().toLowerCase();
          if (labelText.includes('string design')) {
            const field = label.closest('.spb-productoptions-field, fieldset, div[class*="field"]');
        if (field) {
              const checkedInput = field.querySelector('input[type="radio"]:checked');
          if (checkedInput) {
            const inputEl = /** @type {HTMLInputElement} */ (checkedInput);
            const value = (inputEl.getAttribute("data-value") || inputEl.value || '').toLowerCase();
                if (value.includes('two') || value.includes('2')) {
                  isTwoColors = true;
                }
          }
        }
      }
    });

        // Find Second String Color field
    allLabels.forEach(/** @param {HTMLElement} label */ (label) => {
      const labelText = (label.textContent || '').trim().toLowerCase();
          if (labelText.includes('second string color')) {
            const field = label.closest('.spb-productoptions-field, fieldset, div[class*="field"]');
        if (field) {
          const fieldEl = /** @type {HTMLElement} */ (field);
          if (isTwoColors) {
            fieldEl.style.display = '';
            fieldEl.style.visibility = '';
            fieldEl.style.opacity = '';
            fieldEl.removeAttribute('hidden');
          } else {
            fieldEl.style.display = 'none';
            fieldEl.setAttribute('hidden', 'true');
          }
        }
      }
    });
      }

      const update = () => {
        toggleSecondStringColor();
        // Use the Infinite Options container specifically for reading options
        const infiniteOptionsContainer = document.getElementById('infiniteoptions-container') || actualContainer || document.body;
        let containerForUpdate;
        if (infiniteOptionsContainer instanceof Document) {
          containerForUpdate = document.body;
        } else if (infiniteOptionsContainer instanceof HTMLElement) {
          containerForUpdate = infiniteOptionsContainer;
        } else if (infiniteOptionsContainer instanceof Element) {
          // Element type - use as-is, readOptions accepts Element
          containerForUpdate = infiniteOptionsContainer;
        } else {
          containerForUpdate = document.body;
        }
        const containerElForUpdate = containerForUpdate instanceof HTMLElement ? containerForUpdate : document.body;
        console.log('[IGT Options Summary] Update called. Using container:', containerElForUpdate?.id || containerElForUpdate?.className || 'body');
        // readOptions accepts Element|Document|HTMLElement, and containerForUpdate is one of these
        // @ts-ignore - TypeScript type narrowing issue: containerForUpdate is Element|HTMLElement|Document which readOptions accepts
        render(summaryEl, readOptions(containerForUpdate));
      };

      update();
      
      // Watch for changes - including click events for radio buttons
      if (actualContainer) {
        actualContainer.addEventListener("change", update, true);
        actualContainer.addEventListener("input", update, true);
        actualContainer.addEventListener("click", function(e) {
          // If clicking on a radio button, update the summary
          const target = e.target;
          if (target && target instanceof HTMLElement) {
            if ((target instanceof HTMLInputElement && target.type === 'radio') || target.closest('input[type="radio"]')) {
              setTimeout(update, 50); // Small delay to ensure DOM is updated
            }
          }
        }, true);
      }
      
      // Watch entire document for Infinite Options injection
      document.body.addEventListener("change", function(e) {
        const target = e.target;
        if (target && target instanceof HTMLElement && target.closest('#infiniteoptions-container')) update();
      }, true);
      document.body.addEventListener("input", function(e) {
        const target = e.target;
        if (target && target instanceof HTMLElement && target.closest('#infiniteoptions-container')) update();
      }, true);
      document.body.addEventListener("click", /** @param {MouseEvent} e */ function(e) {
        // If clicking on a radio button in Infinite Options, update the summary
        const target = e.target;
        if (target && target instanceof HTMLElement) {
          const isRadio = (target instanceof HTMLInputElement && target.type === 'radio') || target.closest('input[type="radio"]');
          if (isRadio && target.closest('#infiniteoptions-container')) {
            setTimeout(update, 50); // Small delay to ensure DOM is updated
          }
        }
      }, true);

      // if options inject late
      setTimeout(update, 250);
      setTimeout(update, 1000);
      setTimeout(update, 2000);
    }

    // Check again before initializing (in case template was set after DOMContentLoaded)
    if (shouldSkipSummary()) {
      console.log('[IGT Options Summary] Skipping initialization - gift-card template detected');
      return;
    }
    
    tryInit();
    
      // Try again after a delay in case DOM hasn't fully loaded
      // But check again if we should skip
      setTimeout(() => {
        if (shouldSkipSummary()) {
          console.log('[IGT Options Summary] Skipping delayed initialization - gift-card template detected');
          return;
        }
        tryInit();
      }, 100);
      setTimeout(() => {
        if (shouldSkipSummary()) {
          console.log('[IGT Options Summary] Skipping delayed initialization - gift-card template detected');
          return;
        }
        tryInit();
      }, 500);
      
      // Periodically check for and remove duplicate summary boxes
      setInterval(() => {
        if (!shouldSkipSummary()) {
          removeDuplicateSummaryBoxes();
        }
      }, 2000);
  }

  // Run on DOMContentLoaded
  console.log('[IGT Options Summary] Script ready, document state:', document.readyState);
  
    if (document.readyState === 'loading') {
    console.log('[IGT Options Summary] Waiting for DOMContentLoaded');
    document.addEventListener("DOMContentLoaded", init);
    } else {
    // DOM already loaded, run immediately
    console.log('[IGT Options Summary] DOM already loaded, running init immediately');
      init();
  }
  
  // Also try after a short delay to catch late-loading templates and remove if it was created
  setTimeout(() => {
    const template = document.querySelector('main[data-template]')?.getAttribute('data-template');
    console.log('[IGT Options Summary] Delayed check - template:', template);
    if (shouldSkipSummary()) {
      console.log('[IGT Options Summary] Gift card detected in delayed check - removing any existing summary');
      removeSummaryBox();
    }
  }, 2000);
  
  // Keep checking periodically to catch any late-created summary boxes
  setInterval(() => {
    if (shouldSkipSummary()) {
      removeSummaryBox();
    } else {
      // Also check for duplicates on regular product pages
      removeDuplicateSummaryBoxes();
    }
  }, 1000);
})();
